import React, { useContext, useEffect } from "react";
// import images from "../utils/images";
import "../css/footer.css";
// import { GlobalDataContext } from "../GlobalDataContext";
const FooterComponent = ({resultDate,page,bg,gradient,reference,smallref,portalid,kitid}) => {


//   const { kitid,SampleDate } = useContext(GlobalDataContext);
// const kitid = '123456789';
// const SampleDate = '2023-10-01';


const formatDate = (isoDate) => {

  if (!isoDate){return "-"}
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' }); // "May"
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

  return (
    <div className="footer" style={{ background: gradient
      ? "linear-gradient(to right, #E9F7FF, #E6DEFF)"
      : bg || '#f6f3ff'}}>
      <div className="part1">
      {/* <div className="icon">
        <img src={img} alt="" />
      </div> */}
      <div className="data" style={{display: "flex", flexDirection: "column", alignItems: "flex-start",justifyContent: "center"}}>
        {/* <div className="sampleid">Result Date : {formatDate(resultDate)}</div> */}
        <div className="sampleid">Sample ID : {kitid}</div>
        <div className="sampleid">Result Date : {resultDate}</div>
        {/* <div className="sampleid">Sample ID : </div>
        <div className="sampleid">Result Date : </div> */}
      </div>
      </div>
      <div className="part2" style={{width:smallref ? "360px" : "300px",fontSize:smallref ? "9.5px":"11px",lineHeight:"14px",textAlign:"center",marginTop:"5px",marginRight:"60px"}}>
        {reference}
      </div>
      <div className="part2">
        Page {page}
      </div>
    </div>
  );
};

export default FooterComponent;
